import { render } from "./hero-layer.vue?vue&type=template&id=14cd0b07&ts=true"
import script from "./hero-layer.vue?vue&type=script&lang=ts"
export * from "./hero-layer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__